import {Grid} from "@material-ui/core";
import {cardData} from "../DeviceDetailsHelper";
import BoxWithImage from "../../../../../../../../../shared/components/box-with-image/BoxWithImage";
import ConsegneTable from "./consegne-table/ConsegneTable";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import * as actions from "../../../../../../../../../store";

const ConsegneStep = (props) => {
    const tableLoading = useSelector(state => state.contrattoDigitaleReducer.deviceDetails.loading)
    const deviceConsegnati = useSelector(state => state.contrattoDigitaleReducer.deviceDetails.data)
    const qtaConsegnata = deviceConsegnati.qtaConsegnata
    const dispatch = useDispatch()
    const digitalContractId = useSelector(state => state.contrattoDigitaleReducer.contractDetails.data.idTrattativa)

    useEffect(() => {
        dispatch(actions.getDeviceDetailsDataConsgne(digitalContractId, props.data.commercialLabel))
    }, [dispatch, digitalContractId, props.data.commercialLabel])

    return (
        <>
            <Grid container item spacing={2} xs={12}>
                {cardData(props.data, qtaConsegnata, tableLoading).map((item, index) => (
                        <Grid item
                              xs={12}
                              md={4}
                              key={"card-item-" + index}>
                            <BoxWithImage title={item.title}
                                          isWordBreak={index === 0}
                                          content={item.content}
                                          image={item.image}/>
                        </Grid>
                    )
                )}
            </Grid>

            <ConsegneTable loading={tableLoading} handleVediClick={props.handleVediDettagli}/>
        </>
    )
}

export default ConsegneStep